<template>
    <div class="modal" v-show="show">
     <div class="modal-wrapper">
       <div class="modal-container">
             <div class="modal-header">¡Información!</div>
             <div class="modal-body">
               <p>¿Favor seleccionar el mensajer que desea asginar la ruta?</p><br/>
               <select-input :options="status" v-model="newStatus"></select-input>
               <!-- <div class="to-notify">
                   <p>Desactivar la notificación por correo:</p> 
                   <vs-switch v-model="notify" color="success"/>
               </div> -->
             </div>
             <div class="modal-footer">
                 <vs-button color="danger" type="border" icon="block" @click="closeModal()">No, Cancelar</vs-button>
                 <vs-button  :disabled="confirmStatus" id="btnConfirm" color="success" @click="updatePackageStatus()" type="border" icon="check" class="vs-con-loading__container">Si, Actualizar</vs-button>
             </div>  
       </div>
     </div>
   </div>
 </template>
 <script>
 import {helper} from '@/helpers/utils'
 import SelectInput from '@/components/Form/Select-Input.vue'
 import DeliveryService from "@/services/DeliveryService"
 export default {
   name: 'ModalAssignMensajero',
   mixins: [helper],
   components:{
     SelectInput
   },
   props: {
     show: { type: Boolean, required: true },
     packID: { type: String, required: true },
     selected: { type: Object, default: () => {} },
     packIDs: { type: Array, default: () => [] },
     modeUdpdate: { type: Boolean, default: false },
   },
   data() {
     return {
       active: false,
       newStatus: this.selected,
       packageId: this.packID,
       confirmStatus: false,
       notify: false,
       status: [],
     }
   },
   mounted(){
     this.retrieveStatus()
   },
   watch: {
     packID () {
       this.packageId = this.packID
     },
     selected() {
       this.newStatus = this.selected
     }
   },
   methods: {
     closeModal () {
        this.$emit('modal-event', { status: "closed", active: false})
     },
     confirmButton() {
         // console.log(2/222);
       this.$emit('confirm-modal', this.selected, true)
     },
     updatePackageStatus() {
      const that = this
       that.loadingProgress ('#btnConfirm')
       DeliveryService.changeStatusDispatch({ id: this.packageId, st01Code: this.newStatus.code})
       .then(response => {
           console.log(response)
           that.confirmStatus = false
            that.$vs.loading.close('#btnConfirm .con-vs-loading')
            that.$emit('modal-event', { message: response, status:"confirmed", response: this.newStatus, error: false, active: false})
       })
       .catch(e => {
           console.log(e)
           that.confirmStatus = false
           that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
           that.$emit('modal-event', { message: e, status:"confirmed", error: true, active: false})
       });
     },
     retrieveStatus() {
         DeliveryService.getDistribuitors()
         .then(response => {
           this.status = response.data.records;
         })
         .catch(e => {
           console.log(e)
           this.$vs.notify({title:'Error!',text:'Error obteniendo los mensajeros!',color:'danger',icon:'error_outline'})
         });
     },
   }
 }
 </script>
 